import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Box, Button, Typography, Input } from "@mui/material";
import { useSelector } from "react-redux";

const SignatureUpload = ({ onSave }) => {
  const sigPad = useRef(null);
  const { formData } = useSelector((state) => state.ins_info);
  const [signature, setSignature] = useState(null);

  // ✅ Load signature from Redux when component mounts or updates
  useEffect(() => {
    if (formData?.signature) {
      setSignature(formData.signature);
    }
  }, [formData.signature]);

  const clearSignature = () => {
    if (sigPad.current) sigPad.current.clear();
    setSignature(null);
    onSave(null); // Clear from Redux too
  };

  const saveSignature = () => {
    const canvas = sigPad.current;
    if (canvas && !canvas.isEmpty()) {
      // ⚠️ If you're still seeing trim_canvas error, use canvas.toDataURL() instead
      const trimmedDataURL =
        canvas.getTrimmedCanvas?.().toDataURL("image/png") ||
        canvas.toDataURL("image/png");
      setSignature(trimmedDataURL);
      onSave(trimmedDataURL);
    } else {
      alert("Please draw your signature before saving.");
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        setSignature(reader.result);
        onSave(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "500px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        mb: 2,
      }}
    >
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Signature
      </Typography>

      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: 2,
          width: "100%",
          height: 250,
          mb: 2,
          backgroundColor: "#fff",
        }}
      >
        <SignatureCanvas
          ref={sigPad}
          penColor="black"
          canvasProps={{
            width: 500,
            height: 150,
            className: "sigCanvas",
          }}
        />
      </Box>

      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <Button variant="outlined" onClick={clearSignature}>
          Clear
        </Button>
        <Button variant="contained" onClick={saveSignature}>
          Save Signature
        </Button>
      </Box>

      <Typography variant="body2" sx={{ mb: 1 }}>
        or upload a scanned signature:
      </Typography>

      <Input type="file" accept="image/*" onChange={handleFileUpload} />

      {signature && (
        <Box
          sx={{
            mt: 2,
            border: "1px solid #ccc",
            borderRadius: 2,
            p: 1,
            backgroundColor: "#fafafa",
            width: "100%", textAlign: "center"
          }}
        >
          <Typography variant="body2" sx={{ mb: 1 }}>
            Preview:
          </Typography>
          <img
            src={signature}
            alt="signature preview"
            style={{ height: "70px" }}
          />
        </Box>
      )}
    </Box>
  );
};

export default SignatureUpload;
